import { useTranslation } from '../i18n';
import type { TCalculationSummary } from '../types';
import { SummaryCard, SummaryCardSkeleton } from './summary-card';

type TSummaryCardsProps = {
  summary: TCalculationSummary | undefined;
  loading: boolean;
};

const EMPTY_VALUE = '—';

export const SummaryCards = ({ summary, loading }: TSummaryCardsProps) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="tw-grid tw-grid-cols-3 tw-gap-2">
        <SummaryCardSkeleton />
        <SummaryCardSkeleton />
        <SummaryCardSkeleton />
      </div>
    );
  }

  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-2">
      <SummaryCard
        label={t('CARD_TOTAL_COLLABORATORS')}
        value={summary ? String(summary.totalCollaborators) : EMPTY_VALUE}
        subtitle={t('CARD_TOTAL_COLLABORATORS_SUB')}
        variant="default"
      />
      <SummaryCard
        label={t('CARD_OVERTIME_HOURS')}
        value={summary?.totalOvertimeFormatted ?? EMPTY_VALUE}
        subtitle={t('CARD_TEAM_TOTAL')}
        variant="success"
      />
      <SummaryCard
        label={t('CARD_LATE_HOURS')}
        value={summary?.totalLateFormatted ?? EMPTY_VALUE}
        subtitle={t('CARD_TEAM_TOTAL')}
        variant="alert"
      />
    </div>
  );
};
